export type PlanType = 'ppo' | 'epo' | 'pos' | 'hmo' | 'none';

export type AvailableLanguages = 'es' | 'ar' | 'en';

export const AVAILABLE_PLAN_TYPES: { label: string; value: PlanType }[] = [
  { label: 'PPO', value: 'ppo' },
  { label: 'EPO', value: 'epo' },
  { label: 'POS', value: 'pos' },
  { label: 'HMO', value: 'hmo' },
  { label: 'Unknown', value: 'none' },
];

export const AVAILABLE_LANGUAGES: { label: string; value: AvailableLanguages }[] = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'Arabic', value: 'ar' },
];
